import React, { useContext, useEffect, useState, useMemo } from 'react'
import {
  CenteredSpinner,
  Col,
  Row,
  ErrorPageLayout
} from 'react-angle-dashboard-components'
import { useQuery } from 'react-query'
import { useParams, useHistory } from 'react-router-dom'
import { NavbarContext } from '../../components/Navbar/NavbarContext'
import routes from '../../routes/paths'
import { facilityService } from '../../services'
import { AboutSection } from './AboutSection'
import { FacilityProfileContext } from './context'
import { FacilityLocationSection } from './FacilityLocation'
import { HeaderSection } from './HeaderSection'
import { Header, LayoutContainer } from './style'

const Separator: React.FC<{ className?: string }> = ({ className }) => (
  <Row className={className}>
    <Col md="8">
      <hr />
    </Col>
  </Row>
)

export const FacilityProfile = () => {
  const history = useHistory()

  const { setBackInfo } = useContext(NavbarContext)

  useEffect(() => {
    setBackInfo({
      link: routes.facilitiesDirectory,
      text: 'Go Back',
      handleClick: () => history.goBack()
    })
  }, [setBackInfo, history])

  const { id } = useParams<{ id: string }>()

  const { data, isLoading, isError } = useQuery(
    ['facilitiesProfile', id],
    () => facilityService.getById(id),
    { retry: 1 }
  )

  const [selectedLocationIndex, setSelectedLocationIndex] = useState(0)

  const locationComponent = useMemo(() => {
    let facilityLocation = null
    if (data?.location?.lat && data?.location?.lon) {
      facilityLocation = (
        <>
          <FacilityLocationSection
            selectedLocationIndex={selectedLocationIndex}
            setSelectedLocationIndex={setSelectedLocationIndex}
          />
          <LayoutContainer>
            <Separator className="mb-3" />
          </LayoutContainer>
        </>
      )
    }
    return facilityLocation
  }, [
    data?.location?.lat,
    data?.location?.lon,
    setSelectedLocationIndex,
    selectedLocationIndex
  ])

  if (isError) {
    return (
      <ErrorPageLayout
        errorTitle="An unexpected error occurred"
        errorSubtitle="Please contact Member Services if the issue continues"
        button={<a href="tel:+18559371855">(855) 937-1855</a>}
      ></ErrorPageLayout>
    )
  }

  return (
    <>
      {isLoading || !data ? (
        <CenteredSpinner></CenteredSpinner>
      ) : (
        <FacilityProfileContext.Provider value={{ ...data }}>
          <div className="bg-white">
            <Header className="bg-light container-fluid">
              <LayoutContainer>
                <HeaderSection />
              </LayoutContainer>
            </Header>
            <LayoutContainer>
              <AboutSection />
            </LayoutContainer>
            <LayoutContainer>
              <Separator />
            </LayoutContainer>
            {locationComponent}
          </div>
        </FacilityProfileContext.Provider>
      )}
    </>
  )
}

export default FacilityProfile
